<template>
    <el-menu class="left-sidebar-menu" @select="handleSelect" :default-active="$route.path" :default-openeds="['/abroad/doc/sdk']">
        <el-submenu index="/abroad/doc/sdk">
            <template slot="title">
                <i class="el-icon-finished"></i>
                {{ $t("docking.docSdk")}}
            </template>
            <!-- tab 按后端下发的导航树显示，没权限的不出现 -->
            <el-menu-item v-if="can('sdk_doc')" index="/abroad/doc/sdkWord">
                <i class="el-icon-document"></i>
                <span slot="title">{{ $t("docking.docSdkWord")}}</span>
            </el-menu-item>
            <el-menu-item v-if="can('sdk_testing')" index="/abroad/doc/sdkTest">
                <i class="el-icon-odometer"></i>
                <span slot="title">{{ $t("docking.docSdkTest")}}</span>
            </el-menu-item>
            <el-menu-item v-if="can('app_ads_txt')" index="/abroad/doc/appadsTxt">
                <i class="el-icon-document"></i>
                <span slot="title">{{ $t("docking.docAppads")}}</span>
            </el-menu-item>
        </el-submenu>
  </el-menu>
</template>
<script>
    import perm from '@/utils/permission'
    export default {
        created() {
            perm.load().catch(() => {})
        },
        methods: {
           // 导航树还没加载时 hasMenu 全放，按主账号显示
           can(key) {
                return perm.hasMenu(key)
           },
           handleSelect(key, keyPath) {
                return this.$router.push(key)
           },
        }
    }
</script>

<style>
.el-menu-item .bar-chart.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../../../assets/img/bar-chart-grey.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.el-menu-item.is-active .bar-chart.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../../../assets/img/bar-chart-blue.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.el-menu-item .dollar.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../../../assets/img/dollar-grey.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
}
.el-menu-item.is-active .dollar.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:20px;
    height: 20px;
    background:url(../../../../../assets/img/dollar-blue.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
}

</style>
